import { ArdoqId } from '@ardoq/api-types';
import { ApiResponse } from './types';
import { Method, fetchJson, toRequestOptions } from './api';

type DynamicFilterResponse = {
  result: {
    componentIds: ArdoqId[];
    referenceIds: ArdoqId[];
  };
};

const runDynamicFilter = (
  id: string,
  queryParams: {
    selectedId?: ArdoqId;
  }
): ApiResponse<DynamicFilterResponse> => {
  const request = new Request(
    `/api/dynamic-filter/${id}`,
    toRequestOptions(Method.POST, { queryParams })
  );
  return fetchJson<DynamicFilterResponse>(request);
};

export const dynamicFilterApi = {
  runDynamicFilter,
};
